import { AppDataComponent, CompRef } from '@wix/document-services-types';
import {
  AppInstallOption,
  PluginInstallationParams,
} from '@wix/editor-platform-host-integration-apis';
import { getPluginsEditorType } from '../../../../utils';
import {
  autoInstallWithNavigation,
  autoInstall,
} from '../../plugins/pluginAutoPopulateService';
import { getAllPluginsInstallationParams } from '../../slotsService';
import { ExtendedPlatformContext } from '../../../../types/platformApi';

export async function autoPopulatePlugins(
  context: ExtendedPlatformContext,
  appsOptions: AppInstallOption,
  appDefinitionId: string,
  components: AppDataComponent[],
): Promise<void> {
  const pluginInstallationParams = await getAllPluginsInstallationParams(
    context.documentServices,
    appDefinitionId,
    components,
  );

  if (!pluginInstallationParams || pluginInstallationParams.length === 0) {
    return Promise.resolve();
  }

  for (const [index, params] of pluginInstallationParams.entries()) {
    await handleSinglePlugin(
      context,
      appsOptions,
      params,
      index,
      pluginInstallationParams.length,
    ).catch((e) => {
      console.error('Failed to auto populate plugin', {
        error: e,
        params,
      });
    });
  }
}

async function handleSinglePlugin(
  context: ExtendedPlatformContext,
  appsOptions: AppInstallOption,
  params: PluginInstallationParams,
  index: number,
  totalPluginsCount: number,
): Promise<CompRef | null> {
  const shouldNavigate =
    !appsOptions?.pluginsAutoPopulate?.isSilent &&
    index === totalPluginsCount - 1;
  const editorType = getPluginsEditorType();
  const origin = appsOptions?.biData?.origin || '';
  const populateMethod = shouldNavigate
    ? autoInstallWithNavigation
    : autoInstall;

  return populateMethod(
    context,
    context.documentServices,
    params,
    {
      origin,
      editorType,
    },
    context.experimentsAPI,
  );
}
